module.exports = __webpack_public_path__ + "static/media/minimize.d9f10a35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/minimize.svg
// module id = 632
// module chunks = 0